import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import React from 'react';
import { Redirect } from 'react-router-dom';

import AdministrationNavigationIcon from '../../Icons/NavigationItem/Administration';
import companyConfiguration from './Company/companyConfiguration';
import integrationsConfiguration from './Integrations/integrationsConfiguration';
import partnerApiKeysConfiguration from './PartnerApiKeys/partnerApiKeysConfiguration';
import systemAdministrationConfiguration from './SystemAdministration/systemAdministrationConfiguration';

const childItems = [
    companyConfiguration,
    systemAdministrationConfiguration,
    integrationsConfiguration,
    partnerApiKeysConfiguration,
];
const rootRedirection = <Redirect to={childItems[0].navigationItem?.route.url as Required<string>} />;

const administrationConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:title',
    navigationItem: {
        route: {
            text: 'common:sidebar.featureAdministrationTitle',
            url: '/administration',
            Icon: AdministrationNavigationIcon,
            ownerOperatorRoot: rootRedirection,
            tenantRoot: rootRedirection,
            childItems,
        },
        permissions: [UserPermissions.ManageAdminConfig, UserPermissions.ViewUsers],
    },
    disableFeature: [],
};

export default administrationConfiguration;
